import React from 'react';

import {Link, RouteName, RouteParams} from '../../../lib/routes';
import {ChevronDownIcon} from '../svg-icon';
import {cls} from '../../utils';

import css from './tile.module.css';

export type TileAppearance = 'icon' | 'poster';

export type TileProps<K extends RouteName> = {
	route: K;
	params?: RouteParams<K>;
	/** слева от текста: иконка раздела или обложка книги */
	media?: React.ReactNode;
	title: React.ReactNode;
	/** строка под названием: например, английское название книги */
	note?: React.ReactNode;
	description?: React.ReactNode;
	/**
	 * `icon` — иконка раздела слева от текста, `poster` — плитка и есть картинка,
	 * а название лежит на ней снизу.
	 */
	appearance?: TileAppearance;
	className?: string;
};

/**
 * Плитка-ссылка на раздел или книгу: картинка, название с описанием и шеврон.
 * Подсвечивается целиком, поэтому кликать можно в любое место.
 */
export const Tile = <K extends RouteName>({
	route,
	params,
	media,
	title,
	note,
	description,
	appearance = 'icon',
	className,
}: TileProps<K>) => {
	const poster = appearance === 'poster';

	return (
		<Link route={route} params={params} className={cls(css.tile, css[appearance], className)}>
			{media && <span className={css.media}>{media}</span>}
			<span className={css.text}>
				<span className={css.title}>{title}</span>
				{note && <span className={css.note}>{note}</span>}
				{description && <span className={css.description}>{description}</span>}
			</span>
			{/* на афише шеврону некуда встать: там и так вся плитка — ссылка */}
			{!poster && <ChevronDownIcon className={css.chevron} width={16} height={16} />}
		</Link>
	);
};
